import {User} from './user';

export interface UserTrainingInterface {
  id: string;
  name: string;
  licensingAuthority: string;
  status: string;
  expirationDate: string;
  userReminderDays?: number;
  notes: string;
  attachment?: any;
  deleteAttachment?: boolean;
  deleteAttachmentId?: string;
  completedAt?: string;
  user?: User;
  previousAttachments?: any[];
}

export class UserTraining implements UserTrainingInterface {
  id: string;
  name: string;
  licensingAuthority: string;
  status: string;
  expirationDate: string;
  userReminderDays?: number;
  notes: string;
  attachment?: any;
  deleteAttachment?: boolean;
  deleteAttachmentId?: string;
  completedAt?: string;
  user?: User;
  previousAttachments?: any[];

  constructor(data: Partial<UserTrainingInterface>) {
    this.id = data.id!;
    this.name = data.name!;
    this.licensingAuthority = data.licensingAuthority!;
    this.status = data.status!;
    this.expirationDate = data.expirationDate!;
    this.userReminderDays = data.userReminderDays!;
    this.notes = data.notes!;
    this.attachment = data.attachment;
    this.deleteAttachment = data.deleteAttachment;
    this.deleteAttachmentId = data.deleteAttachmentId;
    this.completedAt = data.completedAt;
    this.user = data.user!;
    this.previousAttachments = data.previousAttachments;
  }

  toJson(): UserTrainingInterface {
    return {
      id: this.id,
      name: this.name,
      licensingAuthority: this.licensingAuthority,
      status: this.status,
      expirationDate: this.expirationDate,
      userReminderDays: this.userReminderDays,
      notes: this.notes,
      attachment: this.attachment,
      deleteAttachment: this.deleteAttachment,
      deleteAttachmentId: this.deleteAttachmentId,
      completedAt: this.completedAt,
    };
  }
}
